import * as billMdl from './BillToModel';

export interface ArInvoiceModel {
    invoiceNumber: string,
    billTo: billMdl.BillToModel,
    invoiceDate: string,
    subTotal: number,
    discount: number,
    tax: number,
    total: number,
    balanceDue: number,
    programFee: number,
    isSelectedToPay: boolean,
    invoicePayments: InvoicePayments[],
    invoiceComments: string,
    module: string
}

//export interface ArInvoiceModelJSON {
//    invoiceNumber: string,
//    billTo: billMdl.BillToModel,
//    invoiceDate: string,
//    subTotal: number,
//    discount: number,
//    tax: number,
//    total: number,
//    balanceDue: number,
//    isSelectedToPay: boolean
//}

export interface InvoicePayments {
    
    customerNum: string,
    invoiceNum: string,
    paymentRef: string,
    paymentDate: string,
    paymentAmount: number
}

export const initialState: ArInvoiceModel = {
    invoiceNumber: '',
    billTo: { ...billMdl.initialState },
    invoiceDate: '',
    subTotal: 0,
    discount: 0,
    tax: 0,
    total: 0,
    balanceDue: 0,
    programFee:0,
    isSelectedToPay: false,
    invoicePayments: [],
    invoiceComments: '',
    module:''
};

export interface ArInvoiceModelList {
    items: ArInvoiceModel[];
    loading: boolean;
}

export const initialListState: ArInvoiceModelList = {
    items: [],
    loading: false
}